var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { avatarContentStyle, avatarStyle } from './styles';
function Avatar(_a) {
    var _b = _a.size, size = _b === void 0 ? 'medium' : _b, _c = _a.variant, variant = _c === void 0 ? 'navy' : _c, content = _a.content, _d = _a.contentFill, contentFill = _d === void 0 ? false : _d, restProps = __rest(_a, ["size", "variant", "content", "contentFill"]);
    return (_jsx("div", __assign({ css: avatarStyle({ size: size, variant: variant, contentFill: contentFill }) }, restProps, { children: _jsx("div", __assign({ css: avatarContentStyle({ size: size, contentFill: contentFill }) }, { children: content && typeof content === 'string'
                ? content.charAt(0).toUpperCase()
                : content })) })));
}
export default Avatar;
